module.exports = __webpack_public_path__ + "static/img/wealth_level_60.596533e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_60.png
// module id = YScK
// module chunks = 0